import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { Box, ButtonBase } from '@mui/material';
import * as styles from './CatalogFilterBar.styles';

interface FilterDropdownButtonProps {
  label: string;
  isActive?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const FilterDropdownButton = ({
  label,
  isActive = false,
  onClick,
}: FilterDropdownButtonProps) => (
  <ButtonBase onClick={onClick} sx={styles.dropdownButton}>
    <Box component="span" sx={styles.dropdownButtonLabel(isActive)}>
      {label}
    </Box>
    <ArrowDropDown sx={styles.dropdownButtonIcon(isActive)} />
  </ButtonBase>
);
